import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  saveData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`product/saveProductInfoPerson`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get(`product/findProductPersonBy`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findAllData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`product/findAppletProductList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  generateQrCode({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`product/generateQRUrl`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
